export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14600.3262d68f.jpg";